<template>
    <div style="height: 600px;">
            <vue-data-table
                item-key="id"
                :headers="headers"
                :items="items"
                @click:row="onClickRow"
            >
            </vue-data-table>
    </div>
</template>

<script>
    export default {
        name: "ExampleVueDataTable",
        components: {},
        data() {
            return {
                items: [],
                headers: [],
            }
        },
        created() {
            for (let i = 0; i < 20; i++) {
                this.headers.push({
                    text: "a" + i,
                    value: "a" + i,
                    width: 50,
                },)
            }

            this.headers[0].cellClicked = (v, item) => alert("cell click");
            this.headers[0].itemClass = (v, item) => "red--text";
            this.headers[0].description = "첫 번째 셀 테스트";
            this.headers[0].option = {
                src: (v, item) => '/svg_link.svg',
                description: (v, item) => "" + v,
                descriptionColor: (v, item) => v === 1 ? 'error' : undefined,
            };
        },
        mounted() {
            this.items = [];

            for (let i = 0; i < 30; i++) {
                const obj = {};
                for (let j = 0; j < 20; j++) {
                    const value = "a" + j;
                    obj[value] = i;
                }
                if (i === 0) {
                    obj.a0 = "askljdlaskjdlaksjsajalsd12";
                }
                obj.id = i;
                this.items.push(obj);
            }
        },
        methods: {
            onClickRow(v) {
                this.$alert(v);
            },

            getDataFromApi(page, pageSize) {
                return new Promise((resolve, reject) => {
                    let items = this.getDesserts();
                    items = items.slice((page - 1) * page, page * pageSize);

                    setTimeout(() => {
                        resolve(items);
                    }, 1000)
                })
            },

            getDesserts() {
                return [
                ]
            },
        },
    }
</script>

<style scoped>

</style>